/**
 * THE phone "+" create button (owner, 2026-10-02: "+ looks horrible, doesnt
 * need a background. just a + will do"): a plain blue plus, no fill, with a
 * 44px tap target. Shared by My Tasks (New task) and the Gag Breakdown
 * (New gag) so the phone header rows cannot drift apart — never re-roll it.
 * The CALLER decides whether to render it (any gate stays at the page).
 */
import React from 'react';

export default function PhoneAddButton({ label, onClick, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      data-testid={testId}
      className="h-11 w-11 shrink-0 inline-flex items-center justify-center rounded-lg text-blue-600 dark:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
    >
      <svg aria-hidden="true" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.25}>
        <path strokeLinecap="round" d="M12 5v14M5 12h14" />
      </svg>
    </button>
  );
}
